export default [
  {
    path: '/grupos',
    name: 'app-admin-grupos',
    component: () => import('@/views/apps/grupos-usuarios/grupousuario-list/GruposList.vue'),
    meta: {
      requiresAuth: true,
      action: 'read',
      resource: 'ADMIN_B2C',
      pageTitle: 'Grupos',
      breadcrumb: [
        {
          text: 'Cadastros',
          active: true,
        },
        {
          text: 'Grupos de Usuários',
          active: true,
        },
      ],
    },
  },
]
